<template>
  <div class="laboratory-configuration-info">
    <b-col cols="12">
      <b-form-group
        :label="`${$tc('configuration.identitySection.laboratoryName')} *`"
        :state="!errors.has($tc('configuration.identitySection.laboratoryName'))"
        :invalid-feedback="errors.first($tc('configuration.identitySection.laboratoryName'))"
      >
        <vt-input
          v-model="data.name"
          v-validate="'required'"
          :name="$tc('configuration.identitySection.laboratoryName')"
          type="text"
          class="form-control-sm"
          :class="{'is-invalid': errors.has($tc('configuration.identitySection.laboratoryName')) }"
        />
      </b-form-group>
      <b-form-group
        :label="`${$tc('configuration.identitySection.externalIdentifier')} *`"
        :state="!errors.has($tc('configuration.identitySection.externalIdentifier'))"
        :invalid-feedback="errors.first($tc('configuration.identitySection.externalIdentifier'))"
      >
        <vt-input
          v-model="data.externalId"
          v-validate="'required'"
          :name="$tc('configuration.identitySection.externalIdentifier')"
          class="form-control-sm"
          type="text"
          :class="{'is-invalid': errors.has($tc('configuration.identitySection.externalIdentifier')) }"
        />
      </b-form-group>
      <b-form-group
        :label="`${$tc('configuration.identitySection.associatedCenter')} *`"
        :state="!errors.has($tc('configuration.identitySection.associatedCenter'))"
        :invalid-feedback="errors.first($tc('configuration.identitySection.associatedCenter'))"
      >
        <vt-combo-select
          v-model="data.center"
          v-validate="'required'"
          :name="$tc('configuration.identitySection.associatedCenter')"
          :options="centers"
          label="name"
          :allow-empty="false"
          :class="{'is-invalid': errors.has($tc('configuration.identitySection.associatedCenter')) }"
        />
      </b-form-group>
    </b-col>
  </div>
</template>

<script>
import CenterResource from '@/api/resources/common/commonCenterService'

export default {
    name: 'LaboratoryConfigurationInfo',
    inject: ['formValidator'],
    props: {
        data: { type: Object, required: false }
    },
    data() {
        return {
            centers: []
        }
    },
    computed: {
    },
    created() {
        this.$validator = this.formValidator
    },
    async mounted() {
        await this.loadOptions()
    },
    methods: {
        async loadOptions() {
            this.centers = await CenterResource.getActiveCenters()
        }
    }
}

</script>

<style scoped lang="scss">

</style>
